(() => {
  'use strict';
  if (window.__arioppWhatsAppTracking) return;
  window.__arioppWhatsAppTracking = true;

  // A single delegated listener also handles sections reloaded by the theme editor.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[data-ar-whatsapp-track="product_banner"]');
    if (!link || event.defaultPrevented || event.button !== 0 || window.Shopify?.designMode) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;

    try {
      // Do not transmit the WhatsApp URL, message, visitor details or query parameters.
      const result = window.Shopify.analytics.publish('ariopp:whatsapp_click', {
        button_location: 'product_banner',
        product_id: link.dataset.productId,
        product_name: link.dataset.productName,
        variant_id: link.dataset.variantId,
        product_sku: link.dataset.productSku,
        product_path: link.dataset.productPath,
      });
      Promise.resolve(result).catch(() => {});
    } catch (_) {
      // Analytics must never prevent the visitor from opening WhatsApp.
    }
  });
})();
